export const Filter = [{
    label: "Trending",
    type: "trending",
}, {
    label: "Recent",
    type: "recent",
}, {
    label: "Oldest",
    type: "oldest",
}]